// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Yet9","clinicsSelect":"styles_clinicsSelect__ZsXMU"};